module.exports = __webpack_public_path__ + "static/media/  (169).4c86f347.jpg";